export const LOGIN = {
    EMAIL: "login-email",
    PASSWORD: "login-password",
    SUBMIT: "login-submit",
    ERROR: "login-error",
    REMEMBER_ME: "remember-me",
    CONTACT_REP: "contact-rep",
    REQUEST_ACCESS: "request-access",
    SEND_REQUEST: "send-request",
    LOGIN_FORM: "branded-login-form",
    BRANDED_LOGIN_IMG: "branded-login-img",
    SITE_LOGIN_IMG: "branded-login-img",
    FORGOT_PASSWORD_CONTAINER: "forgot-password-container",
    FORGOT_PASSWORD_LINK: "forgot-password-link",
    RECAPTCHA: "recaptcha",
    LOGIN_HELP_LINK: "login-help-link",
    HELP_VIDEO_IFRAME: "help-video-iframe",
    NOT_A_CUSTOMER: "not-a-customer",
    RETAILER_SIGNUP: "retailer-signup",
    BRAND_SIGNUP: "brand-signup",
    CONTACT_REP_HEADER: "contact-rep-header",
    SWITCH_SSO: "switch-login-flow-sso",
    SWITCH_NORMAL: "switch-login-flow-normal",
    YOUR_NAME: "your_name",
    STORE_NAME: "store_name",
    REQUEST_EMAIL: "request_email",
    REQUEST_PHONE: "request_phone",
    BACKGROUND_SLIDER: "background-slider",
    SALES_CONTACT_EMAIL: "sales-contact-email",
    SALES_CONTACT_TITLE: "sales-contact-title",
    SALES_CONTACT_NAME: "sales-contact-name",
    SALES_CONTACT_PHONE: "sales-contact-phone",
};
